import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import { alignType } from './types';

interface Props {
  children?: React.ReactNode;
  paddingCell?: number;
  align?: alignType;
}

const HeadCellRoot = styled(Box)(({ theme }) => ({
  color: theme.palette.darkGrey.main,
  fontSize: theme.typography.pxToRem(14),
  fontWeight: 500,
  paddingBlock: '0.5rem',
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
}));

const HeadCell = ({ children, paddingCell = 2, align = 'center', ...others }: Props) => {
  return (
    <HeadCellRoot aria-label="HeadCell" justifyContent={align} padding={paddingCell} {...others}>
      {children}
    </HeadCellRoot>
  );
};

export default HeadCell;
